import { addProtocol } from '../../../utils/addProtocol';
import { makeTransition, TransitionType } from '../../../utils/styles/makeTransition';
import { useTranslation } from '../../../utils/useTranslation';
import { IconArrowDiagonalRight } from '../../icon/IconArrowDiagonalRight';
import { IconCalendar } from '../../icon/IconCalendar';
import { IconForward } from '../../icon/IconForward';
import { IconNewTab } from '../../icon/IconNewTab';
import { IconProduct } from '../../icon/IconProduct';
import { IconPurchases16 } from '../../icon/IconPurchases16';
import { Button } from '../../input/Button';
import { IconButton } from '../../input/IconButton';
import { Box } from '../../layout/Box';
import { PostCardProductButton } from './parts/PostCardProductButton/PostCardProductButton';
import { MainButton, ProductContainer, ProductContent, ProductMinizeButton } from './styles';
import { PostButtonProps } from './types';

export const PostButton = ({
    onClickOutClick,
    clickOut,
    products,
    businessType,
    isProductExpanded,
    transitionTiming,
    hasBookingButton,
    onProductButtonClick,
}: PostButtonProps) => {
    const t = useTranslation();

    const withCheckout = products.items.some((product) => product.checkout);

    const isMultipleProducts = products.items.length > 1;

    if (products.items.length) {
        return (
            <MainButton onClick={onProductButtonClick}>
                <ProductMinizeButton
                    isProductExpanded={isProductExpanded}
                    transition={makeTransition({
                        ms: isProductExpanded ? 0 : transitionTiming,
                        styles: ['opacity'],
                        type: TransitionType.EASE_OUT,
                    })}
                >
                    <Box mr="10px">
                        <IconProduct size={20} />
                    </Box>
                    {t(products.buttonTitle)}
                </ProductMinizeButton>

                <ProductContainer
                    isProductExpanded={isProductExpanded}
                    transition={makeTransition({
                        ms: isProductExpanded ? transitionTiming : 0,
                        styles: ['opacity'],
                        type: TransitionType.EASE_OUT,
                    })}
                >
                    <ProductContent>
                        <PostCardProductButton products={products} businessType={businessType} />
                    </ProductContent>
                    {isMultipleProducts ? (
                        <IconForward fontSize="16px" />
                    ) : (
                        <IconButton
                            isHoverEnabled={false}
                            backgroundColor={withCheckout ? 'var(--search-red)' : 'white'}
                            color={withCheckout ? 'white' : 'black'}
                        >
                            {withCheckout ? (
                                <IconPurchases16 size={16} />
                            ) : (
                                <IconArrowDiagonalRight size={16} />
                            )}
                        </IconButton>
                    )}
                </ProductContainer>
            </MainButton>
        );
    }

    if (clickOut) {
        const isMapsBooking = clickOut.type === 'map';

        return (
            <Button
                as="a"
                target="_blank"
                rel="nofollow noreferrer"
                flexGrow={1}
                href={addProtocol(clickOut.url)}
                color="hardLight"
                onClick={onClickOutClick}
                width="100%"
                fontSize="1rem"
            >
                {isMapsBooking || hasBookingButton ? (
                    <>
                        <Box mr={0.5}>
                            <IconCalendar fontSize={14} color="var(--always-black)" />
                        </Box>
                        {isMapsBooking ? t('Бронь') : t('Записаться')}
                    </>
                ) : (
                    <>
                        {clickOut.text}
                        <Box ml={1}>
                            <IconNewTab fontSize={14} color="var(--always-black)" />
                        </Box>
                    </>
                )}
            </Button>
        );
    }

    return null;
};
